import { api } from "./apiConfig";

export const getTimeOffBlocks = async () => {
  const { data } = await api.get("/time-off");
  return data;
};

export const createTimeOffBlock = async (payload) => {
  const { data } = await api.post("/time-off", payload);
  return data;
};

export const updateTimeOffBlock = async ({ id, payload }) => {
  const { data } = await api.put(`/time-off/${id}`, payload);
  return data;
};

export const deleteTimeOffBlock = async (id) => {
  await api.delete(`/time-off/${id}`);
};
